import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Menu = () => {

    return (
        <div className="main">
            <div className="main-top">
                <div className="main-top-bg">
                    <div className="main-top-block">
                        <ul className="main-top-menu">
                        <h2 className="main-top-menu-title">MENU</h2>
                            <li>
                                <AnchorLink href="#1" className="scroll-to">全身リフレッシュコース</AnchorLink>
                            </li>
                            <li>
                                <AnchorLink href="#2" className="scroll-to">ヘッドドレナージュ</AnchorLink>
                            </li>
                            <li>
                                <AnchorLink href="#3" className="scroll-to">フェイシャル①</AnchorLink>
                            </li>
                            <li>
                                <AnchorLink href="#4" className="scroll-to">フェイシャル②</AnchorLink>
                            </li>
                            <li>
                                <AnchorLink href="#5" className="scroll-to">よもぎ蒸し</AnchorLink>
                            </li>
                            <li>
                                <AnchorLink href="#6" className="scroll-to">お得なコラボメニュー</AnchorLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Menu